import React, { useEffect, useState } from "react";
import Loader from "../Common/Loader";
import commonFunction from "../../Utils/commonFunction";
import Seo from "../../Seo/Seo";
import { webPageSchema } from "../../Seo/jsonld";
import { getRouteSeo } from "../../Seo/routeSeo";
import { demoteHeadings } from "../../Utils/html";

const PrivacyPolicy = () => {

  const [loader, setLoader] = useState(true);
  const [pageData, setPageData] = useState("");
  const [pageHeading, setPageHeading] = useState("");

  useEffect(() => {

    window.scrollTo(0, 0);

    // Looked up by title, not by numeric id.
    //
    // The id is not stable across environments: the privacy policy is page 3 on
    // production but page 9 on the development API. The original code hardcoded
    // 9, so the page rendered empty on production; hardcoding 3 instead just
    // moved the breakage to development. Title lookup resolves correctly on
    // both (verified against each API, and the match is case-insensitive).
    commonFunction.getPageByTitle("privacy policy")
      .then((res) => {
        setPageData(res?.data?.page?.description);
        setPageHeading(res?.data?.page?.heading);
        setLoader(false);
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });

  }, []);

  if (loader) {
    return <Loader />;
  }

  const seo = getRouteSeo("/privacy-policy");

  return (
    <React.Fragment>
      <main>
        <Seo
          type="article"
          jsonLd={[
            webPageSchema({
              title: seo?.title,
              description: seo?.description,
              url: "/privacy-policy",
            }),
          ]}
        />

        {/* Hero Section */}
        <section className="page-info-sec">
          <div
            className="bg-fixed wow fadeIn"
            data-wow-delay="0.1s"
            style={{ background: 'url("/assets/img/page-info1.png")' }}
          />

          <div
            className="bg-fixed img-overlay wow fadeIn"
            data-wow-delay="0.2s"
          />

          <div className="container">
            <div className="row align-items-center justify-content-center">
              <div className="col-md-12">

                <div
                  className="page-info-block wow fadeInUp"
                  data-wow-delay="0.3s"
                >
                  {/* The CMS `heading` for this page is the lowercase English
                      string "privacy policy"; the rest of the site is Danish, and
                      this heading has to agree with the nav label, the footer link
                      and the <title>. The CMS heading is still rendered as part of
                      the body content below. */}
                  <h1>Privatlivspolitik</h1>

                  <div className="btm-line-2 text-center justify-content-center">
                    <span></span>
                    <span></span>
                  </div>

                </div>

              </div>
            </div>
          </div>
        </section>

        {/* Content Section */}

        <section className="sec-pd rel-z-1">
          <div className="container">

            <div className="row">
              <div className="col-md-12">

                <div
                  className="title-1 wow fadeInUp"
                  data-wow-delay="0.1s"
                >

                  <div
                    dangerouslySetInnerHTML={{ __html: demoteHeadings(pageData) }}
                  />

                </div>

              </div>
            </div>

          </div>
        </section>

      </main>
    </React.Fragment>
  );
};

export default PrivacyPolicy;